// removed by extract-text-webpack-plugin
module.exports = {"modal":"_1xdAeK","overlay":"_3dgsjQ","overlayAfteropen":"DnYuUQ","modalContent":"_18mZQ8","closeButton":"_2-GHni","afterOpen":"_2r5MNS","linkList":"_2XQXA5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/modal-style.css
// module id = 78
// module chunks = 0